import {CountUp} from 'countup.js';
window.CountUp = CountUp;
